import { Trans, useTranslation } from 'next-i18next'
import { useState, useEffect } from 'react'

import { Modal } from './Modal'
import { CurrencyType, EventHookInterface } from '../../types'
import { CTA } from '../CTA'
import { H3 } from '../H3'
import { H5 } from '../H5'
import { RefundDiv } from './processPaymentModalStyles'
import { P } from '../Headings'

export const RefundPaymentModal: React.FC<{
  eventHook: EventHookInterface
  onClose: (success?: boolean) => void
  setUserStatus: (status: boolean) => void
}> = ({ onClose, eventHook, setUserStatus }) => {
  const { t } = useTranslation('common')

  const { removeCurrentUserFromEvent, isInside24hrs, value } = eventHook
  const { is_recurring: isRecurrent, currency } = value

  const [loading, setLoading] = useState(false)
  const [refundError, setRefundError] = useState('')
  const [allowToRefund, setAllowToRefund] = useState(false)

  const refund = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setRefundError('')
    setLoading(true)

    let refundSuccess = false

    try {
      await removeCurrentUserFromEvent()
        .then(() => {
          refundSuccess = true
          setUserStatus(false)
        })
        .catch((error) => {
          console.error(error)
          setRefundError(
            t(
              'Error occurs while processing your cancelation request',
              'Error occurs while processing your cancelation request',
            ),
          )
        })
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
      if (refundSuccess) {
        onClose(true)
      }
    }
  }

  const cancelAllEvents = () => {
    // TODO add logic after server logic will be implemented
    console.log('cancelAllEvents')
  }

  const cancelSingleEvent = () => {
    // TODO add logic after server logic will be implemented
    console.log('cancelSingleEvent')
  }
  useEffect(() => {
    setAllowToRefund(!isInside24hrs())
  }, [isInside24hrs])

  const paymentCost = currency === CurrencyType.IDR ? '5%' : '2.9% + 50¢'

  return (
    <Modal close={() => onClose()}>
      <RefundDiv>
        {/* Header. */}
        <H3 className="header">
          {t(
            `ProcessPaymentModal-375968220`,
            `Cancel my registration to this event`,
          )}
        </H3>
        {allowToRefund && (
          <H5 className="content">
            <Trans i18nKey="ProcessPaymentModal-1178378214">
              By cancelling your registered attendance to this event more than
              24 hours out from the event date you are elligable for a refund.
              This is a full refund minus the original transaction cost of{' '}
              {{ paymentCost }}.
            </Trans>
          </H5>
        )}
        {!allowToRefund && (
          <H5 className="content">
            {t(
              `ProcessPaymentModal-2017410455`,
              `Cancelling your registered attendance less than 24 hours out from the event date is a non-refundable action. You will not be reimbursed for the cost of your ticket.`,
            )}
          </H5>
        )}
        {isRecurrent ? (
          <div className="refundButtonContainer">
            <div className="buttonGroup">
              <CTA
                className="outline-red button"
                onClick={cancelAllEvents}
                disabled={loading}>
                {t(`Cancel all events`, `Cancel all events`)}
              </CTA>
              <CTA
                className="red button"
                onClick={cancelSingleEvent}
                disabled={loading}>
                {t(`Cancel single event`, `Cancel single event`)}
              </CTA>
            </div>
            {refundError && <P className="detail refundError">{refundError}</P>}
          </div>
        ) : (
          <div className="refundButtonContainer">
            <CTA
              className="red button refundButton"
              onClick={refund}
              disabled={loading}>
              {t(`Confirm cancelation`, `Confirm cancelation`)}
            </CTA>
            {refundError && <P className="detail refundError">{refundError}</P>}
          </div>
        )}
        {/* Back Button. */}
        <CTA className="button closeButton" onClick={() => onClose()}>
          {t(`Go back`, `Go back`)}
        </CTA>
      </RefundDiv>
    </Modal>
  )
}
